const getModalSize = (size) => {
    switch (size) {
        case 'small':
            return '450px';
        case 'large':
            return '1080px';
        case 'medium':
        default:
            return '600px';
    }
};

export { getModalSize };
